import { render, staticRenderFns } from "./CheckChimpXp.vue?vue&type=template&id=1c9bc800&scoped=true&"
import script from "./CheckChimpXp.vue?vue&type=script&lang=ts&"
export * from "./CheckChimpXp.vue?vue&type=script&lang=ts&"
import style0 from "./CheckChimpXp.vue?vue&type=style&index=0&id=1c9bc800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9bc800",
  null
  
)

export default component.exports